import { twMerge } from 'tailwind-merge';

// Shared VIP flag (#1525): the 'vip' tag written from order history (server
// shared/vip.js VIP_TAG). One helper + one badge so every surface that shows the
// flag — admin user page, admin Users list, support-chat list + DM header —
// renders it identically. Separate from the manual 'concierge' tag.

const VIP_TAG = 'vip';

// users.tags is a Postgres text[] but can arrive as a comma-joined string.
export function hasVipTag(user?: Pick<API.User, 'tags'> | null): boolean {
  const tags = user?.tags;
  if (Array.isArray(tags)) {
    return tags.includes(VIP_TAG);
  }
  return typeof tags === 'string' && tags.split(',').includes(VIP_TAG);
}

// Solid amber star mark, no inline text (#1816). The "VIP" label stays out of
// the way but reveals on hover (a compact hover-expand) and is always present
// in the accessibility tree, so screen readers announce it even while it is
// visually collapsed. `title` gives the full description as a native tooltip.
export function VipBadge({ className }: { className?: string }) {
  return (
    <span
      className={twMerge(
        'group/vip inline-flex shrink-0 items-center rounded-full text-amber-500 dark:text-amber-400',
        className,
      )}
      title="VIP: high-value customer (tagged from order history)"
    >
      <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="size-3.5 shrink-0">
        <path d="M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.5L10 14.6l-4.95 2.6.95-5.5-4-3.9 5.53-.8L10 1.5z" />
      </svg>
      <span className="max-w-0 overflow-hidden text-xs font-semibold whitespace-nowrap opacity-0 transition-[max-width,opacity,margin] duration-200 ease-out group-hover/vip:ml-1 group-hover/vip:max-w-[2.5rem] group-hover/vip:opacity-100">
        VIP
      </span>
    </span>
  );
}
